import type { Page } from '@aigc/types';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type {
  SkillDto,
  SkillMutationInputDto,
  SkillOptionDto,
  SkillQueryInputDto,
} from './model';

export const skill_query_key = ['技能管理'] as const;

export function getSkillOptionssQueryOptions() {
  return queryOptions({
    queryKey: [...skill_query_key, '选项'],
    queryFn: () => http.get('skill-options').json<SkillOptionDto[]>(),
  });
}

export function getSkillsQueryOptions(input: SkillQueryInputDto) {
  return queryOptions({
    queryKey: [...skill_query_key, '列表', input],
    queryFn: () =>
      http
        .get('skills', {
          searchParams: {
            page: input.page,
            size: input.size,
            ...(input.name ? { name: input.name } : {}),
          },
        })
        .json<Page<SkillDto>>(),
  });
}

export const createSkillMutationOptions = mutationOptions({
  mutationKey: [...skill_query_key, '新增'],
  meta: { invalidates: [{ queryKey: skill_query_key }] },
  mutationFn: (input: SkillMutationInputDto) =>
    http.post('skills', { json: input }).json<SkillDto>(),
});

export const updateSkillMutationOptions = mutationOptions({
  mutationKey: [...skill_query_key, '编辑'],
  meta: { invalidates: [{ queryKey: skill_query_key }] },
  mutationFn: ({
    skill_id,
    input,
  }: {
    skill_id: number;
    input: SkillMutationInputDto;
  }) => http.patch(`skills/${skill_id}`, { json: input }).json<SkillDto>(),
});

export const deleteSkillMutationOptions = mutationOptions({
  mutationKey: [...skill_query_key, '删除'],
  meta: { invalidates: [{ queryKey: skill_query_key }] },
  mutationFn: (skill_id: number) => http.delete(`skills/${skill_id}`),
});
